import {useSignInContext} from "../context/SignInContextProvider";
import {useForgotPasswordContext} from "../context/ForgotPasswordContextProvider";
import {Alert} from "@gs-ux-uitoolkit-react/alert";
import React from "react";

export function ErrorMessage() {
    const {error} = useSignInContext();
    return (
        <Alert
            visible
            status="warning"
            size="lg"
            emphasis="bold"
            className={`min-w-[384px] mb-2 ${error ? 'visible' : 'invisible'}`}
        >
            {error}
        </Alert>
    );
}


export function ErrorMessageForgotPassword() {
    const {error} = useForgotPasswordContext();
    return (
        <Alert
            visible
            status="warning"
            size="lg"
            emphasis="bold"
            className={`min-w-[384px] mb-2 ${error ? 'visible' : 'invisible'}`}
        >
            {error}
        </Alert>
    );
}

export function SuccessMessageForgotPassword() {
    const {success} = useForgotPasswordContext();
    return (
        <Alert
            visible
            status="success"
            size="lg"
            emphasis="bold"
            className={`min-w-[384px] mb-2 ${success ? 'visible' : 'invisible'}`}
        >
            {success}
        </Alert>
    );
}
